export { default as algorithms } from './algorithms'
export { default as Api } from './api'
export { default as Auth } from './auth'
export { default as TextEdit } from './textedit'
export { default as Timestamps } from './timestamps'



// WEBPACK FOOTER //
// ./src/js/services/index.js